import environment from "../../environment";
import { GET } from "../http.service";

export const getConfiguration = async () => {
    const response = await GET(environment.Configuration);
    return response;
};